import React from "react";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";

import ButtonWithSpinner from "../ButtonWithSpinner";
import ContactWalletField from "../ContactWalletField";

const ContactBatchWalletModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  selectedCount,
  value,
  onChange,
}) => {
  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="contact-batch-wallet-dialog"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="contact-batch-wallet-dialog">
        Definir carteira em lote
      </DialogTitle>
      <DialogContent dividers>
        <Box display="grid" gridGap={16}>
          <Box display="flex" alignItems="center" justifyContent="space-between" gridGap={12} flexWrap="wrap">
            <Typography variant="body1">
              Contatos selecionados
            </Typography>
            <Chip
              color="primary"
              variant="outlined"
              label={`${selectedCount} contato${selectedCount === 1 ? "" : "s"}`}
              size="small"
            />
          </Box>

          <Box display="grid" gridGap={8}>
            <Typography variant="body2" color="textSecondary">
              Os usuarios selecionados substituirao a carteira atual dos contatos escolhidos.
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Se nenhum usuario for selecionado, os contatos ficarao publicos.
            </Typography>
          </Box>

          <ContactWalletField
            value={value}
            onChange={onChange}
            disabled={loading}
            label="Usuarios da carteira"
            placeholder="Selecione um ou mais usuarios"
            helperText={null}
            margin="none"
            size="small"
            limitTags={2}
          />

          <Box display="flex" justifyContent="flex-start">
            <Button
              color="default"
              size="small"
              onClick={() => onChange([])}
              disabled={loading || !Array.isArray(value) || value.length === 0}
            >
              Deixar contatos publicos
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default" disabled={loading}>
          Cancelar
        </Button>
        <ButtonWithSpinner
          loading={loading}
          onClick={onConfirm}
          color="primary"
          variant="contained"
        >
          Salvar carteira
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default ContactBatchWalletModal;
